import { fetchQuery, requestSubscription } from 'react-relay'
import {
  tableExitedSubscription,
  tableUpdatedSubscription,
} from '../components/inHouseGames/InHouseGame'

import { InHouseGameTableExitedSubscription } from '../components/inHouseGames/__generated__/InHouseGameTableExitedSubscription.graphql'
import { InHouseGameTableUpdatedSubscription } from '../components/inHouseGames/__generated__/InHouseGameTableUpdatedSubscription.graphql'
import { ModalType, openModalTask } from '../components/modalComponent/modalComponent'
import { listTablesQuery, Table } from '../components/tables/TablesComponent'
import { TablesComponentTablesQuery } from '../components/tables/__generated__/TablesComponentTablesQuery.graphql'
import { TableConstant } from './multiplayer.reducer'
import { store } from '@src/store'
import Env from '../RelayEnvironment'
import ConfigurationService from '@src/service/ConfigurationService'
import { convertUnit } from '@src/service/coins/coins'

export const initMultiplayer = () => {
  fetchQuery<TablesComponentTablesQuery>(Env, listTablesQuery, { page: 1 }).subscribe({
    next: (data) => {
      store.dispatch({ type: TableConstant.SET_ALL_TABLES, tables: data.tables })
    },
  })
  requestSubscription<InHouseGameTableUpdatedSubscription>(Env, {
    subscription: tableUpdatedSubscription,
    variables: {},
    onNext: (data) => {
      if (data?.tableUpdated) {
        const event = data?.tableUpdated as unknown as Table
        store.dispatch({ type: TableConstant.UPDATE_TABLE, table: event })
      }
    },
  })
  requestSubscription<InHouseGameTableExitedSubscription>(Env, {
    subscription: tableExitedSubscription,
    variables: {},
    onNext: (data: any) => {
      if (data?.tableExited.uuid) {
        const tableExited = data?.tableExited as { uuid: string }
        store.dispatch({ type: TableConstant.REMOVE_TABLE, tableUuid: tableExited.uuid })
      } else {
        const tableExited = data?.tableExited as {
          winner: string
          virtual_id: number
          winner_name: string
          fund: number
        }
        if (undefined !== tableExited?.winner) {
          const openedTable = store.getState().multiplayer.openedTable
          if (openedTable?.virtualId === tableExited.virtual_id) {
            const username = tableExited.winner_name ? tableExited.winner_name : tableExited.winner.substring(0, 8)
            const amount = formatTableAmount(openedTable, tableExited.fund)
            openModalTask.next({ type: ModalType.winner, winnerModal: { amount, username } })
          }
        }
      }
    },
  })
}

export const formatTableAmount = (table: Table, amount: number): string => {
  if (undefined === table) {
    return ''
  }
  const currency = ConfigurationService.instance.getCurrency(
    table.type === 'FREEROLL' ? table.meta?.freeroll_win_currency : table.currency
  )
  return convertUnit(amount, currency.m_unit!, currency.s_unit!, currency.format!) + currency.format!
}
